import { alpha, Chip, Tooltip } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_COMPONENT_REVIEW } from "../../feature-flag-component-review"

const DRAFT_TOOLTIP = "This component is a draft. It will not appear in searches until it has been approved."

export function DraftChip({ item }) {
    const theme = useTheme()

    if (!item?.draft) return null
    if (!isEnabled(FEATURE_FLAG_COMPONENT_REVIEW)) return null

    return (
        <Tooltip title={DRAFT_TOOLTIP} placement="top" arrow>
            <Chip
                data-cy="component-draft-chip"
                size="small"
                label="Draft"
                sx={{
                    flexShrink: 0,
                    ml: 1,
                    fontWeight: 600,
                    backgroundColor: alpha(theme.palette.warning.main, 0.2),
                    color: theme.palette.warning.dark,
                }}
            />
        </Tooltip>
    )
}
